"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "menu-title" };
var _hoisted_2 = { class: "menu-title" };
var SubMenu_vue_1 = __importDefault(require("./SubMenu.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SubMenu',
    props: {
        item: {
            require: true,
            default: function () { return {}; }
        },
    },
    setup: function (__props) {
        /* eslint-disable */
        return function (_ctx, _cache) {
            var _a, _b;
            var _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            var _component_el_sub_menu = (0, vue_2.resolveComponent)("el-sub-menu");
            var _component_el_menu_item = (0, vue_2.resolveComponent)("el-menu-item");
            return (__props.item.children && __props.item.children.length > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_sub_menu, {
                    key: 0,
                    index: __props.item.name
                }, {
                    title: (0, vue_2.withCtx)(function () {
                        var _a, _b;
                        return [
                            (0, vue_2.createVNode)(_component_el_icon, null, {
                                default: (0, vue_2.withCtx)(function () {
                                    var _a, _b;
                                    return [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((_b = (_a = __props.item) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.icon)))
                                    ];
                                }),
                                _: 1
                            }),
                            (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)((_b = (_a = __props.item) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.title), 1)
                        ];
                    }),
                    default: (0, vue_2.withCtx)(function () { return [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.item.children, function (element) {
                            var _a;
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                                key: element.name
                            }, [
                                (element.children && element.children.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_sub_menu, {
                                        key: 0,
                                        index: element.name
                                    }, {
                                        title: (0, vue_2.withCtx)(function () {
                                            var _a;
                                            return [
                                                (0, vue_2.createVNode)(_component_el_icon, null, {
                                                    default: (0, vue_2.withCtx)(function () {
                                                        var _a;
                                                        return [
                                                            ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((_a = element === null || element === void 0 ? void 0 : element.meta) === null || _a === void 0 ? void 0 : _a.icon)))
                                                        ];
                                                    }),
                                                    _: 2
                                                }, 1024),
                                                (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((_a = element === null || element === void 0 ? void 0 : element.meta) === null || _a === void 0 ? void 0 : _a.title), 1)
                                            ];
                                        }),
                                        default: (0, vue_2.withCtx)(function () { return [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(element.children, function (subitem) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SubMenu_vue_1.default, {
                                                    key: subitem.name,
                                                    item: subitem
                                                }, null, 8, ["item"]));
                                            }), 128))
                                        ]; }),
                                        _: 2
                                    }, 1032, ["index"]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                        (!((_a = element === null || element === void 0 ? void 0 : element.meta) === null || _a === void 0 ? void 0 : _a.hidden))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_menu_item, {
                                                key: 0,
                                                index: element.path
                                            }, {
                                                title: (0, vue_2.withCtx)(function () {
                                                    var _a;
                                                    return [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((_a = element === null || element === void 0 ? void 0 : element.meta) === null || _a === void 0 ? void 0 : _a.title), 1)
                                                    ];
                                                }),
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    (0, vue_2.createVNode)(_component_el_icon, null, {
                                                        default: (0, vue_2.withCtx)(function () {
                                                            var _a;
                                                            return [
                                                                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((_a = element === null || element === void 0 ? void 0 : element.meta) === null || _a === void 0 ? void 0 : _a.icon)))
                                                            ];
                                                        }),
                                                        _: 2
                                                    }, 1024)
                                                ]; }),
                                                _: 2
                                            }, 1032, ["index"]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ], 64))
                            ], 64));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["index"]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                    (!((_b = (_a = __props.item) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.hidden))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_menu_item, {
                            key: 0,
                            index: __props.item.path
                        }, {
                            title: (0, vue_2.withCtx)(function () {
                                var _a, _b;
                                return [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((_b = (_a = __props.item) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.title), 1)
                                ];
                            }),
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(_component_el_icon, null, {
                                    default: (0, vue_2.withCtx)(function () {
                                        var _a, _b;
                                        return [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((_b = (_a = __props.item) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.icon)))
                                        ];
                                    }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["index"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 64));
        };
    }
});
